import React, {createContext, useContext} from "react";

const SearchResultsContext = createContext();
const useSearchResultsContext = () => useContext(SearchResultsContext);

export {SearchResultsContext, useSearchResultsContext}